
import ContentBlock from "@/Components/ContentBlock.vue";
import FaqComponent from "@/Components/FaqComponent.vue";
import TourListing from "@/Components/Tour/TourListing.vue";
import Tours from "@/Components/Tour/Tours.vue";
import RelatedTours from "@/Components/Tour/RelatedTours.vue";
import PostItem from "@/Components/Blog/PostItem.vue";
import PostListing from "@/Components/Blog/PostListing.vue";
import ReviewsShortcode from "@/Components/Reviews/ReviewsShortcode.vue";
import VideoPlaceholder from "@/Components/VideoPlaceholder.vue";
import AppImage from "@/Components/AppImage.vue";
import SearchComponent from "@/Components/SearchComponent.vue";
import { Button } from "primevue";

const definedComponents = {
    "primary-button": Button,
    "tours": Tours,
    "related-tours": RelatedTours,
    "related_tours": RelatedTours,
    "tour-listing": TourListing,
    "tour_listing": TourListing,
    "content_block": ContentBlock,
    "content-block": ContentBlock,
    "faqs": FaqComponent,
    "post": PostItem,
    "post-item": PostItem,
    "posts": PostListing,
    "post-listing": PostListing,
    "reviews": ReviewsShortcode,
    "tour-reviews": ReviewsShortcode,
    "tour_reviews": ReviewsShortcode,
    "video-placeholder": VideoPlaceholder,
    "app-image": AppImage,
    "search-component": SearchComponent,
     "search_component": SearchComponent,
};

export default definedComponents;
